import React from 'react';
import { Settings, Download, Grid, List, LoaderCircle, Tag } from 'lucide-react';
import { ViewMode } from '../MoldList/types';

interface ButtonGroupProps {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  onDownload: () => void;
  onDownloadLabels?: () => void;
  setIsColumnSelectorOpen: (open: boolean) => void;
  filterButtonRef?: React.RefObject<HTMLButtonElement>;
  showSettings?: boolean;
  count?: number | null;
  isDownloading?: boolean;
}

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
  viewMode,
  setViewMode,
  onDownload,
  onDownloadLabels,
  setIsColumnSelectorOpen,
  showSettings = true,
  count = null,
  isDownloading = false,
}) => {
  const countText = count !== null ? ` (${count})` : '';
  return (
    <div className="flex items-center sm:space-x-1 justify-end sm:justify-between sm:justify-end py-3 gap-1 sm:gap-0">
      {showSettings && viewMode === 'table' && (
        <button
          type="button"
          aria-label="เลือกคอลัมน์ที่แสดง"
          title="เลือกคอลัมน์ที่แสดง"
          onClick={() => setIsColumnSelectorOpen(true)}
          className="p-2 rounded hover:bg-gray-100"
        >
          <Settings size={20} />
        </button>
      )}
      <button
        type="button"
        disabled={isDownloading}
        aria-busy={isDownloading}
        className="flex items-center px-3 py-2 bg-white text-gray-700 rounded-lg border hover:bg-gray-100 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-400"
        onClick={onDownload}
      >
        {isDownloading ? (
          <LoaderCircle className="mr-1 h-4 w-4 animate-spin" aria-hidden="true" />
        ) : (
          <Download className="mr-1 h-4 w-4 text-slate-900" />
        )}
        <span className="text-sm hidden sm:block">
          {isDownloading ? 'กำลังดาวน์โหลด...' : `ส่งออก CSV${countText}`}
        </span>
      </button>
      {onDownloadLabels && (
        <button
          className="flex items-center px-3 py-2 bg-white text-gray-700 rounded-lg border hover:bg-gray-100 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
          onClick={onDownloadLabels}
        >
          <Tag className="w-4 h-4 text-slate-900 mr-1" />
          <span className="text-sm hidden sm:block">ดาวน์โหลดป้าย{countText}</span>
        </button>
      )}
      <div className="flex rounded-lg border overflow-hidden">
        <button
          className={`p-1.5 ${viewMode === 'card' ? 'bg-slate-500 text-white' : 'hover:bg-gray-100'}`}
          onClick={() => setViewMode('card')}
          title="Card View"
        >
          <Grid size={24} />
        </button>
        <button
          className={`p-1.5 ${viewMode === 'table' ? 'bg-slate-500 text-white' : 'hover:bg-gray-100'}`}
          onClick={() => setViewMode('table')}
          title="Table View"
        >
          <List size={24} />
        </button>
      </div>
    </div>
  );
};

export default ButtonGroup;
